import eventBus from '@refapp/eventbus-js';
import { tryParseJson } from './utils';

export default {
  methods: {
    getKeyByValue(object, value) {
      return Object.keys(object).find((key) => object[key] === value);
    },
    eventPropertiesReplacer(eventProperties, matchPatterns) {
      let eventPropertiesAsString = JSON.stringify(eventProperties);

      for (const [key, replaceValue] of Object.entries(matchPatterns)) {
        eventPropertiesAsString = eventPropertiesAsString.replaceAll(key, replaceValue);
      }
      return tryParseJson(eventPropertiesAsString);
    },
    pushToDataLayer(eventProperties, eventData) {
      if (!eventData) return false;

      //   if (!window.wsf) {
      //     window.wsf = {};
      //   }
      //   const { ecommerce } = window.wsf;

      const matchPatterns = {
        '[zipcode or city]': eventData.zipcodeOrCity
          ? eventData.zipcodeOrCity.toLocaleLowerCase()
          : '',
        '[marker popup location]': eventData.markerPopupLocation
          ? eventData.markerPopupLocation
          : '',
        '[store name]': eventData.storeName ? eventData.storeName.toLocaleLowerCase() : '',
        '[keyword]': eventData.storeName ? eventData.storeName.toLocaleLowerCase() : '',
        '[socialNetwork]': eventData.socialNetwork
          ? eventData.socialNetwork.toLocaleLowerCase()
          : '',
        '[socialTarget]': eventData.socialTarget ? eventData.socialTarget.toLocaleLowerCase() : '',
      };

      //   if (this.getKeyByValue(eventProperties, '[ecommerce]') !== undefined) {
      //     eventProperties[this.getKeyByValue(eventProperties, '[ecommerce]')] = ecommerce
      //       ? ecommerce
      //       : '';
      //   }

      if (!window.dataLayer) return false;

      window.dataLayer.push(this.eventPropertiesReplacer(eventProperties, matchPatterns));
      return true;
    },
  },
  created() {
    eventBus.on('rfpTaggingPushToDatalayer', (data) => {
      if (!data || !data.tags || !data.values) {
        return;
      }
      this.pushToDataLayer(data.tags, data.values);
    });
  },
};
